window.mcb.forms.fields = window.mcb.forms.fields || {};
window.mcb.forms.fields.extensions = window.mcb.forms.fields.extensions || {};
window.mcb.forms.fields.extensions.date = function (parent, shared) {
    const _logger = window.mcb.utilities.createLogger("forms.field.date", 'Forms Field (Date)');
    const _thisField = parent;
    const _shared = shared;
    let _validatedControlWrapper = null;
    let _control = null;
    let _preview = null;
    let _validationCanvas = null;

    {
        // Init
        _thisField.validation = {
            required: _thisField.settings.required ?? false,
            regexError: _thisField.settings.data.regexError ?? "DateViolation",
            dirty: false
        };

        const dateFormat = window.mcb.forms.helpers.getDateFormat(_thisField.formId, _thisField.settings.data.dateonly);
        const sageFormat = window.mcb.forms.helpers.getSageDateFormat(dateFormat);
        const options = {
            useLang: di.language
        };

        if (dateFormat.indexOf('h') >= 0) {
            options.timeFormat = 12;
        }

        if (_thisField.settings.data.dateonly === false) {
            options.mode = "datetimebox";
            options.datetimeFormat = sageFormat
            jQuery.jtsage.datebox.prototype.options.lang[di.language].datetimeFormat = sageFormat;
        }
        else {
            options.dateFormat = sageFormat;
            jQuery.jtsage.datebox.prototype.options.lang[di.language].dateFormat = sageFormat;
        }

        if (_thisField.settings.data.limiter === '>[today]') {
            options.afterToday = true;
        }
        else if (_thisField.settings.data.limiter === '>=[today]') {
            options.minDays = 0;
        }

        _thisField.sage = {
            dateFormat,
            options
        };
    }

    const render = function (target) {
        const sageWrapper = document.createElement('div');
        _control = document.createElement('input');
        sageWrapper.append(_control);

        _control.classList.add(window.mcb.forms.constants.fields.controlClass);
        _control.classList.add(window.mcb.forms.constants.fields.uiInput);
        _control.classList.add(window.mcb.forms.constants.fields.dateClass);
        _control.id = _thisField.fieldValueControlId;
        _control.name = _thisField.alias;
        _control.type = 'text';
        _control.dataset.role = 'datebox';
        _control.dataset.format = _thisField.sage.dateFormat;
        _control.dataset.options = JSON.stringify(_thisField.sage.options);

        if (_thisField.settings.aria !== null) {
            _control.ariaLabel = _thisField.settings.aria;
        }

        if (_thisField.settings.placeholder !== null) {
            _control.placeholder = _thisField.settings.placeholder;
        }

        if (_thisField.settings.defaultValue === '[today]') {
            _control.value = new Date().toLocaleDateString();
            _control.dataset.dirty = true;
        }

        _preview = document.createElement('div');
        _preview.classList.add(window.mcb.forms.constants.fields.previewClass);
        sageWrapper.append(_preview);

        _control.addEventListener('focus', (event) => {
            _shared.validateEvent(event, _thisField, _control);
            _shared.fireFieldModifiedEvents(_control, _thisField.applyValidationDuringInput);
        });

        _control.addEventListener('paste', (event) => {
            _shared.validateEvent(event, _thisField, _control);
            _shared.fireFieldModifiedEvents(event._control, _thisField.applyValidationDuringInput);
        });

        _control.addEventListener('keyup', (event) => {
            _shared.validateEvent(event, _thisField, _control);
            _shared.fireFieldModifiedEvents(event._control, _thisField.applyValidationDuringInput);
        });

        _control.addEventListener('change', (event) => {
            _shared.validateEvent(event, _thisField, _control);
            _shared.fireFieldModifiedEvents(event._control, true, true);
        });

        _validationCanvas = document.createElement('div');
        _validationCanvas.classList.add(window.mcb.forms.constants.validation.validationTarget);

        _validatedControlWrapper = document.createElement('div');
        _validatedControlWrapper.classList.add(window.mcb.forms.constants.validation.validationWrapper);

        _validatedControlWrapper.appendChild(sageWrapper);
        _validatedControlWrapper.appendChild(_validationCanvas);

        return _validatedControlWrapper;
    };

    const getValue = function (allowValueFormatting = false) {
        window.mcb.forms.validation.clearValidationResults(_validationCanvas);

        if (_control === null) {
            throw new Error("Control is not initialized");
        }

        if (document.getElementById(_control.id) === null) {
            throw new Error("Control has been removed from DOM");
        }

        if (_control.offsetParent === null) {
            // Field is not visible
            return undefined;
        }

        var jControl = jQuery("#" + _thisField.fieldValueControlId);
        let value = jControl.val();

        const validation = new window.mcb.forms.validation.ValidationResult(true);
        if (_thisField.validation.required === true) {
            validation.aggregate(window.mcb.forms.validation.validateRequired(_thisField.alias, value));
        }

        if (validation.isValid()) {
            validation.aggregate(validateDate(value));
        }

        validation.render(_thisField.formId, _validatedControlWrapper, _validationCanvas);
        if (validation.isValid()) {
            return value.replace(/-/g, ".").replace(/\//g, ".");;
        }

        return null;
    };

    const setValue = function (value) {
        var jControl = jQuery("#" + _thisField.fieldValueControlId);
        if (jControl.length > 0) {
            jControl.datebox({});
            if (value !== null) {
                jControl.datebox('setTheDate', value);
            }

            return true;
        }

        return false;
    }

    const updatePreview = function (jControl = null, date = null) {
        if (jControl === null || date === null) {
            _preview.innerText = '';
        }
        else {
            let datePartFormat = di.language === 'en' ? '%A, %B %-d. %Y' : "%A, %-d. %B, %Y";
            let format = _thisField.sage.dateFormat.indexOf('hh') < 0 && _thisField.sage.dateFormat.indexOf('HH') < 0 ? datePartFormat : "%H:%M, " + datePartFormat;

            if (di.language === 'en') {
                let day = jControl.datebox("callFormat", "%-d", date);
                if (day === '1') {
                    day += 'st';
                }
                else if (day === '2') {
                    day += 'nd';
                }
                else if (day === '3') {
                    day += 'rd';
                }
                else {
                    day += 'th';
                }

                format = format.replace('\%-d.', day + ',');
            }

            _preview.innerText = jControl.datebox("callFormat", format, date);
        }
    }

    const validateDate = function (value) {
        _logger.trace('Validating Date for ' + _thisField.alias);

        updatePreview();

        if (value === "") {
            return new window.mcb.forms.validation.ValidationResult(true);
        }

        const validationByRegEx = window.mcb.forms.validation.validateByRegEx(
            _thisField.alias,
            value,
            "^" + _thisField.sage.dateFormat.replace(/[dmyh]/gi, "[0-9]") + "$",
            _thisField.validation.regexError);

        if (!validationByRegEx.isValid()) {
            _logger.trace(_thisField.alias + ' is Violating Date Parsing RegEx', value);
            return validationByRegEx;
        }

        let mi = _thisField.sage.dateFormat.indexOf("MM");
        let monthVal = parseInt(value.substring(mi, mi + 2));
        let valid = false;
        if (0 < monthVal && monthVal < 13) {
            let di = _thisField.sage.dateFormat.indexOf("dd");
            let dayVal = parseInt(value.substring(di, di + 2));
            let yi = _thisField.sage.dateFormat.indexOf("yyyy");
            let yearVal = parseInt(value.substring(yi, yi + 4));

            let daysInMonth = 0;
            switch (monthVal) {
                case 2:
                    daysInMonth =
                        (yearVal % 4 === 0 && yearVal % 100) || yearVal % 400 === 0 ? 29 : 28;
                    break;
                case 4:
                case 6:
                case 9:
                case 11:
                    daysInMonth = 30;
                    break;
                default:
                    daysInMonth = 31;
                    break;
            }

            if (0 < dayVal && dayVal <= daysInMonth) {
                valid = true;
            }
        }

        if (valid !== true) {
            _logger.trace(_thisField.alias + ' is Violating Date Validation Logic', value);
            return new window.mcb.forms.validation.ValidationResult(false, _thisField.validation.regexError);
        }

        var jControl = jQuery("#" + _thisField.fieldValueControlId);
        let date = jControl.datebox("getTheDate");
        let format = window.mcb.forms.helpers.getSageDateFormat(_thisField.sage.dateFormat);
        let dateString = jControl.datebox("callFormat", format, date);
        if (dateString !== value) {
            jControl.datebox('setTheDate', value);
            date = jControl.datebox("getTheDate");
            format = window.mcb.forms.helpers.getSageDateFormat(_thisField.sage.dateFormat);
            dateString = jControl.datebox("callFormat", format, date);

            if (dateString !== value) {
                jControl.val(value);
                date = jControl.datebox("getTheDate");
                format = window.mcb.forms.helpers.getSageDateFormat(_thisField.sage.dateFormat);
                dateString = jControl.datebox("callFormat", format, date);
            }
        }

        if (dateString === value) {
            updatePreview(jControl, date);
        }
        else {
            _logger.trace(_thisField.alias + ' is Violating Picked Date', value);
            return new window.mcb.forms.validation.ValidationResult(false, "DateViolationUsePicker");
        }

        let options = jControl.data('options');
        let afterToday = options.afterToday ?? false;
        let minDays = afterToday === true ? 1 : (options.minDays ?? null);
        if (minDays !== null) {
            let diffDays = (date - new Date()) / 86400000;
            diffDays = diffDays < 0 ? Math.ceil(diffDays) : Math.floor(diffDays);
            if (diffDays < minDays) {
                _logger.warn(_thisField.alias + ' Date Value "' + dateString + '" is ' + diffDays + ' from today, which is in conflict with the limit of ' + minDays);
                return new window.mcb.forms.validation.ValidationResult(false, "DateViolationTooEarly");
            }
        }

        return new window.mcb.forms.validation.ValidationResult(true);
    };

    return _ = {
        render: render,
        getValue: getValue,
        setValue: setValue
    };
};
